export class AttributesSectionEditorViewModel
{
    opened: boolean = false;
    newName: string | null = null;
    oldName: string | null = null;

    show(name: string)
    {
        this.newName = name;
        this.oldName = name;
        this.opened = true;
    }

    close()
    {
        this.opened = false;
        this.newName = null;
        this.oldName = null;
    }
}